import React, { useContext } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { UserContext } from '../../../App';
import { hanldeSignOut } from '../../Login/LoginMain/LoginManager';
import Pop from '../Pop/Pop';
// import './Navbar.css';
import toast, { Toaster } from 'react-hot-toast';
import { useState } from 'react';
import { useEffect } from 'react';
import { AuthContext } from '../../Context/AuthContext';


const Appointment_Navbar = () => {
    const { user, loading, error, dispatch } = useContext(AuthContext);
    const [isSticky, setSticky] = useState(false)

    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.scrollY > 50) {
                setSticky(true)
            } else {
                setSticky(false)
            }
        })
    }, [])
    return (
        <nav className={`navbar navbar-expand-lg navbar-light ${isSticky ? "stickynav" : "normalnav"}`} expand="lg">
            <Toaster />
            <div className="container-fluid mx-3">
                <div className="navbar-heading">
                    <h3>
                        <Link className="navbar-h" to="/">Krishna Dental India</Link>
                    </h3>
                </div>
                {/* <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button> */}

                <div className="" id="navbarSupportedContent">
                    <ul className="list-unstyled mb-2 mb-lg-0 ms-auto">
                        {/* <li className="nav-item">
                            <a className="nav-link active me-3" aria-current="page" href="/">HOME</a>
                        </li> */}

                        <div className="dropdown">

                            <li className="nav-item">
                                {user?.email ?
                                    <Pop />
                                    :
                                    <span>
                                        <Link className={`nav-link me-3 text-white ${isSticky ? "textDark" : "textWhite"}`} to="/login">LOGIN</Link>
                                    </span>
                                }
                            </li>
                        </div>
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default Appointment_Navbar;